<template>
  <v-app id="inspire" style="background: #000">
    <router-view></router-view>
    
    <loader></loader>
  </v-app>
</template>

<script>
import Loader from '@/components/shared/loader.vue'
export default {
  name: 'App',
  components: {
    Loader
  },
  data: () => ({
    accounts: []
  }),
  methods: {

  },
  created () {
    console.log(" checking server ")
    this.$store.commit('loader', false);
  },
};
</script>

<style  scoped>
  
</style>
